module.exports = __webpack_public_path__ + "static/media/60 - Logo-PPI-Delft.e5192b04.png";